import StripeSection from './StripeSection';
import BankTransferDefaultsCard from './BankTransferDefaultsCard';

/**
 * Tab "Metodi di pagamento": i due modi in cui chi incassa riceve i pagamenti dei
 * clienti. Qui si configurano; nella singola proposta il TA sceglie quali rendere
 * disponibili. La tab esiste solo per chi incassa (agenzia, indipendente, admin): il
 * membro del team usa account e conto dell'agenzia.
 */
const PaymentMethodsPage = () => (
  <div className="space-y-6">
    <StripeSection />
    <BankTransferDefaultsCard />
  </div>
);

export default PaymentMethodsPage;
